import {PropsWithChildren} from "react";

import {PropsWithClassName} from "@/lib/types/props.ts";

export interface EmptyTableProps extends PropsWithChildren, PropsWithClassName {
  colSpan?: number;
  width?: string;
}
export const EmptyTable = ({
  children,
  colSpan = 100,
  className = "p-2 pulseTextBodySmall",
  width = "100%",
}: EmptyTableProps) => (
  <tr>
    <td className={className} width={width} colSpan={colSpan}>
      {children}
    </td>
  </tr>
);
